<div class="flex gap-1 mb-3 bg-slate-100 p-1">
  <button *ngFor="let tab of tabList ; index as i"
    class="flex-1 px-3 py-2 font-bold transition-all duration-100 focus:outline-none hover:scale-105 hover:bg-blue-950 hover:text-white"
    [ngClass]="i+1 === step_details?.step_mapping?.phase_sequence ? 'bg-blue-950 text-white rounded transform scale-105 hover:scale-105' : 'bg-blue-50 text-blue-800  border-2 border-blue-600'">
    {{ tab.name }}
  </button>
</div>

<app-trans-header-steper *ngIf="topRender" (currentStepChange)="currentStepChange($event)"></app-trans-header-steper>

<div class="mt-4">
  <div class="flex items-center justify-between mb-8 w-full">
    <div
      class="flex flex-nowrap items-center gap-1 bg-slate-200 p-1 rounded-xl border border-slate-300 shadow-sm overflow-x-auto">
      <ng-container *ngFor="let t of [
        { code: 'process', icon: 'pi-sitemap', txt: 'Process Flow', tip: 'View flow', action:'' },
        { code: 'comments', icon: 'pi-comments', txt: 'Comments', tip: 'View notes', action:'' },
        { code: 'report', icon: 'pi-file-pdf', txt: 'Reports', tip: 'Access reports', action:'getReportData' },
        { code: 'document', icon: 'pi-folder', txt: 'Documents', tip: 'Manage files', action:'getDocumentList' }
      ]">
        <button
          class="px-4 py-1 rounded-lg font-bold text-sm transition-all duration-300 flex items-center gap-2.5 whitespace-nowrap"
          [ngClass]="userGuide === t.code
            ? 'bg-slate-100 text-blue-700 shadow-md ring-1 ring-slate-300'
            : 'text-slate-700 hover:text-blue-700 hover:bg-slate-100/80'"
          (click)="userGuide = t.code; t.action && this[t.action]()" [pTooltip]="t.tip" tooltipPosition="top">

          <i class="pi text-base" [ngClass]="[t.icon, userGuide === t.code ? 'text-blue-700' : 'text-slate-500']"></i>
          <span>{{ t.txt }}</span>
        </button>
      </ng-container>
    </div>

  </div>

  <!-- Content Grid -->
  <div class="mt-3">
    <div class="grid grid-cols-1">
      <div *ngIf="userGuide === 'process'">
        <div class="bg-white rounded-xs shadow " *ngIf="step_details">
          <ng-container [ngSwitch]="step_details?.code">
            <!-- Initiation & approval phase -->
            <app-idex *ngSwitchCase="'T-IP'" (generatePDFEmitter)="generatePDF($event)" (routeConfig)="showConfirm()"
              [id]="step_details.id" [stepDetails]="step_details" [schemeType]="'tdf'" [url]="'/tdf/need-generation/'"
              [screening]="'initiation'"></app-idex>

            <app-idex *ngSwitchCase="'makeI_02'" (generatePDFEmitter)="generatePDF($event)"
              (routeConfig)="showConfirm()" [id]="step_details.id" [stepDetails]="step_details" [schemeType]="'tdf'"
              [url]="'/tdf/approval/need-generation/'"></app-idex>
            <app-idex *ngSwitchCase="'A-VCNS'" (generatePDFEmitter)="generatePDF($event)" (routeConfig)="showConfirm()"
              [isViewOnly]="true" [id]="step_details.id" [stepDetails]="step_details" [schemeType]="'tdf'"
              [url]="'/tdf/vcns/need-generation/'"></app-idex>
            <app-idex *ngSwitchCase="'tdf_tpr'" (generatePDFEmitter)="generatePDF($event)" (routeConfig)="showConfirm()"
              [id]="step_details.id" [stepDetails]="step_details" [schemeType]="'tdf'"
              [url]="'/tdf/draft-tpr/'"></app-idex>

            <app-preliminary-discussion *ngSwitchCase="'tdf_012'" [id]="step_details.id" [step]="step_details"
              (generatePDFEmitter)="generatePDF($event)" (routeConfig)="showConfirm()"
              [stepDetails]="step_details"></app-preliminary-discussion>

            <app-seek-proposal *ngSwitchCase="'R-SP'" [id]="step_details.id" [step]="step_details"
              [getUrl]="'/revenue/seek-proposal/?proposal_step='" [schemeType]="'tdf'"
              [postUrl]="'/revenue/seek-proposal/'" (generatePDFEmitter)="generatePDF($event)"
              [stepDetails]="step_details"></app-seek-proposal>

            <app-initiation-of-proposal *ngSwitchCase="'R-IP'" [id]="step_details.id" [step]="step_details"
              [getUrl]="'/revenue/initiation-of-proposal/?proposal_step='" [schemeType]="'tdf'"
              [postUrl]="'/revenue/initiation-of-proposal/'" (generatePDFEmitter)="generatePDF($event)"
              [stepDetails]="step_details"></app-initiation-of-proposal>

            <app-aip *ngSwitchCase="'R-AIP'" [id]="step_details.id" [step]="step_details"
              [getUrl]="'/revenue/aip-details/?proposal_step='" [postUrl]="'/revenue/aip-details/'"
              (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details"></app-aip>
            <!-- DRDO PDD -->
            <app-pdd *ngSwitchCase="'tdf_drdopdd'" [id]="step_details.id" [url]="'/tdf/drdo-pdd/'" [commentLabel]="'PDD Format'"
              [visibleField]="{e:true,f:true}" [stepDetails]="step_details" (routeConfig)="showConfirm()"></app-pdd>

            <!-- Upload Approved QAP and ATP -->
            <app-pdd *ngSwitchCase="'Rev_012'" [id]="step_details.id" [visibleField]="{e:false,f:true}"
              [stepDetails]="step_details" (routeConfig)="showConfirm()"></app-pdd>
            <!-- Approve PDR  -->
            <app-pdd *ngSwitchCase="'tdf_apppdr'" [id]="step_details.id" [url]="'/tdf/approve/pdr/'"
              [visibleField]="{e:true,f:true}" [stepDetails]="step_details" (routeConfig)="showConfirm()"></app-pdd>
            <!-- Approved CDR Document -->
            <app-pdd *ngSwitchCase="'tdf_appcdr'" [id]="step_details.id" [url]="'/tdf/approve/cdr/'"
              [visibleField]="{e:true,f:true}" [stepDetails]="step_details" (routeConfig)="showConfirm()"></app-pdd>
            <!-- Final PDD -->
            <app-pdd *ngSwitchCase="'tdf_finalpdd'" [id]="step_details.id" [visibleField]="{e:false,f:true}"
              [url]="'/tdf/final-pdd/'" [stepDetails]="step_details" (routeConfig)="showConfirm()"></app-pdd>
            <!-- Preparation of SoC for AoN -->
            <app-pdd *ngSwitchCase="'tdf_soc-aon'" [id]="step_details.id" [visibleField]="{e:false,f:true}"
              [stepDetails]="step_details" (routeConfig)="showConfirm()"></app-pdd>

            <!--  Fats Prototype  -->
            <app-pdd *ngSwitchCase="'tdf_fats_r'" [id]="step_details.id" [url]="'/tdf/fats/prototype/'"
              [visibleField]="{e:true,f:true}" [stepDetails]="step_details" (routeConfig)="showConfirm()"></app-pdd>
            <!--  Preparation of SOC  -->
            <app-pdd *ngSwitchCase="'makeI_08'" [id]="step_details.id" [url]="'/tdf/prepation/soc/'"
              [visibleField]="{e:true,f:true}" [stepDetails]="step_details" (routeConfig)="showConfirm()"></app-pdd>
            <!--  Preparation of SOC  -->
            <app-pdd *ngSwitchCase="'tdf_appsoc'" [id]="step_details.id" [visibleField]="{e:false,f:true}"
              [stepDetails]="step_details" (routeConfig)="showConfirm()"></app-pdd>
            <!--  RFP Document Formulation of SOC  -->
            <app-pdd *ngSwitchCase="'TDF-RFP'" [id]="step_details.id" [url]="'/tdf/rfp/document/'"
              [visibleField]="{e:true,f:true}" [stepDetails]="step_details" (routeConfig)="showConfirm()"></app-pdd>
            <!--  PMMG Committe  -->
            <app-pdd *ngSwitchCase="'pmmg_con'" [id]="step_details.id" [visibleField]="{e:false,f:true}"
              [stepDetails]="step_details" (routeConfig)="showConfirm()"></app-pdd>
            <!--  Issuance of RFP of SOC  -->
            <app-pdd *ngSwitchCase="'I-RFP'" [id]="step_details.id" [url]="'/tdf/issuance/rfp/'"
              [visibleField]="{e:true,f:true}" [stepDetails]="step_details" (routeConfig)="showConfirm()"></app-pdd>

            <!-- prototypes Hats and SATs -->
            <app-upload-hat-sat *ngSwitchCase="'tdf_hat'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [proposalName]="proposalName" [proposalId]="proposalId"
              [url]="'/tdf/hat-sat/prototype/'" (routeConfig)="showConfirm()"></app-upload-hat-sat>
            <!-- prototypes  SATs -->
            <app-upload-hat-sat *ngSwitchCase="'tdf_sats'" [id]="step_details?.id" [step]="step_details"
              [stepDetails]="step_details" [proposalName]="proposalName" [proposalId]="proposalId"
              [url]="'/tdf/hat-sat/prototype/'" (routeConfig)="showConfirm()"></app-upload-hat-sat>

            <!-- Project sanction -->
            <app-feasibilty-study *ngSwitchCase="'makeI_06'" [id]="step_details.id" [step]="step_details"
              (routeConfig)="showConfirm()" (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details"
              [schemeType]="'tdf'"></app-feasibilty-study>

            <app-drdo-aip *ngSwitchCase="'D-AIP'" [id]="step_details.id" [step]="step_details"
              (routeConfig)="showConfirm()" (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details"
              [schemeType]="'tdf'"></app-drdo-aip>

            <app-concurrence-rfi *ngSwitchCase="'C-RFI'" [proposalName]="proposalName"
              (generatePDFEmitter)="generatePDF($event)" [id]="step_details.id" [step]="step_details"
              (routeConfig)="showConfirm()" [stepDetails]="step_details"
              [proposalId]="proposalId"></app-concurrence-rfi>

            <app-draft-tpr *ngSwitchCase="'tdf_05'" [id]="step_details.id" [step]="step_details"
              (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details"></app-draft-tpr>

            <app-constitute-committee *ngSwitchCase="'tdf_005'" [id]="step_details.id" [step]="step_details"
              [title]="'Constitute Committee'" [getUrl]="'revenue/constitute-committee/'"
              [postUrl]="'revenue/constitute-committee/'" (generatePDFEmitter)="generatePDF($event)"
              (routeConfig)="showConfirm()" [stepDetails]="step_details"></app-constitute-committee>

            <app-aon *ngSwitchCase="'aon_mom'" [id]="step_details.id" [step]="step_details"
              (routeConfig)="showConfirm()" [stepDetails]="step_details"></app-aon>

            <app-aon *ngSwitchCase="'AON-PRE'" [id]="step_details.id" [step]="step_details"
              (routeConfig)="showConfirm()" [stepDetails]="step_details"></app-aon>

            <app-vendor *ngSwitchCase="'R-VI'" [id]="step_details.id" [step]="step_details"
              (routeConfig)="showConfirm()" [stepDetails]="step_details" [schemeType]="'tdf'"></app-vendor>

            <app-firm-response-submission *ngSwitchCase="'RS-TDF'" [id]="step_details.id" [step]="step_details"
              [schemeType]="'tdf'" [stepDetails]="step_details" [proposalName]="proposalName" [format]="'upload'"
              [url]="'/tdf/dms-file/vendor/'" (routeConfig)="showConfirm()"></app-firm-response-submission>

            <app-firm-response-submission *ngSwitchCase="'FRE'" [id]="step_details.id" [step]="step_details"
              [schemeType]="'tdf'" [stepDetails]="step_details" [proposalName]="proposalName" [format]="'upload'"
              [url]="'/tdf/dms-file/vendor/'" (routeConfig)="showConfirm()"></app-firm-response-submission>

            <app-eoi *ngSwitchCase="'R-EoI'" [id]="step_details.id" [step]="step_details"
              [getUrl1]="'/revenue/eol-details/?proposal_step='" [postUrl1]="'/revenue/eol-details/'"
              (generatePDFEmitter)="generatePDF($event)" [masterData]="masterData"
              [stepDetails]="step_details"></app-eoi>

            <app-upload-doc *ngSwitchCase="'R-UEOID'" [id]="step_details.id" [step]="step_details"
              [stepDetails]="step_details" [schemeType]="'tdf'"></app-upload-doc>

            <app-shortlisting-vendors *ngSwitchCase="'R-SLV'" [id]="step_details.id" [step]="step_details"
              [schemeType]="'tdf'" [stepDetails]="step_details"></app-shortlisting-vendors>



            <app-upload-dpr *ngSwitchCase="'makeI_15'" [id]="step_details.id" [step]="step_details"
              [proposalName]="proposalName" [schemeType]="'tdf'" (generatePDFEmitter)="generatePDF($event)"
              [stepDetails]="step_details"></app-upload-dpr>

            <app-upload-dpr *ngSwitchCase="'dpr_011'" [id]="step_details.id" [step]="step_details"
              [proposalName]="proposalName" [schemeType]="'tdf'" (generatePDFEmitter)="generatePDF($event)"
              [format]="'upload'" [stepDetails]="step_details"></app-upload-dpr>

            <app-idex-commercial-rfp *ngSwitchCase="'makeI_14'" [id]="step_details.id" [step]="step_details"
              [proposalName]="proposalName" (generatePDFEmitter)="generatePDF($event)" (routeConfig)="showConfirm()"
              [schemeType]="'tdf'" [stepDetails]="step_details"></app-idex-commercial-rfp>

            <app-dpr-submission *ngSwitchCase="'DPR-SUB'"
              [urls]="{getUrl:'/tdf/dpr-submission/',evalUrl:'/tdf/vendor-identification/',vUrl:'/tdf/dms-file/vendor/'}"
              [projectName]="proposalName" [stepDetails]="step_details" (routeConfig)="showConfirm()"
              [schemeType]="'tdf'"></app-dpr-submission>

            <app-award-of-contract *ngSwitchCase="'makeI_35'" [id]="step_details.id" [step]="step_details"
              (routeConfig)="showConfirm()" (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details"
              [schemeType]="'tdf'"></app-award-of-contract>

            <app-award-of-contract *ngSwitchCase="'AWD-PRO'" [id]="step_details.id" [step]="step_details"
              (routeConfig)="showConfirm()" (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details"
              [schemeType]="'tdf'"></app-award-of-contract>

            <app-commercial-evaluation *ngSwitchCase="'R-FEC'" [id]="step_details.id" [step]="step_details"
              [schemeType]="'tdf'" (routeConfig)="showConfirm()" [stepDetails]="step_details"
              (generatePDFEmitter)="generatePDF($event)"></app-commercial-evaluation>

            <app-constitute-committee *ngSwitchCase="'tdf_013'" [id]="step_details.id" [step]="step_details"
              [title]="'Constitute CNC'" [getUrl]="'revenue/constitute-committee/'"
              [postUrl]="'revenue/constitute-committee/'" (generatePDFEmitter)="generatePDF($event)"
              [stepDetails]="step_details"></app-constitute-committee>

            <app-commercial-negocatition *ngSwitchCase="'tdf_006'" [id]="step_details.id" [step]="step_details"
              (routeConfig)="showConfirm()" [schemeType]="'tdf'" [stepDetails]="step_details"
              (generatePDFEmitter)="generatePDF($event)"></app-commercial-negocatition>

            <app-constitute-contract-negotiation-committee *ngSwitchCase="'makeI_32'" [id]="step_details.id"
              [step]="step_details" (routeConfig)="showConfirm()" [schemeType]="'tdf'" [stepDetails]="step_details"
              (generatePDFEmitter)="generatePDF($event)"></app-constitute-contract-negotiation-committee>

            <app-banchmark *ngSwitchCase="'R-BM'" [id]="step_details.id" [step]="step_details"
              (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details"
              (routeConfig)="showConfirm()"></app-banchmark>

            <app-sanction-order *ngSwitchCase="'tdf_014'" [id]="step_details.id" [step]="step_details"
              [schemeType]="'tdf'" [getUrl]="'revenue/sanction-order/'" [postUrl]="'revenue/sanction-order/'"
              (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details"></app-sanction-order>

            <!-- Prototype phase -->
            <app-idex-prototype *ngSwitchCase="'tdf_016'" [proposalName]="proposalName" [proposalId]="proposalId"
              [step]="step_details" (generatePDFEmitter)="generatePDF($event)" [schemeType]="'tdf'"
              [stepDetails]="step_details"></app-idex-prototype>

            <app-preliminary-design *ngSwitchCase="'tdf_022'" [id]="step_details.id" [step]="step_details"
              (generatePDFEmitter)="generatePDF($event)" (routeConfig)="showConfirm()"
              [stepDetails]="step_details"></app-preliminary-design>

            <app-critical-design *ngSwitchCase="'tdf_023'" [id]="step_details.id" [step]="step_details"
              (generatePDFEmitter)="generatePDF($event)" (routeConfig)="showConfirm()"
              [stepDetails]="step_details"></app-critical-design>

            <app-idex-utrr *ngSwitchCase="'tdf_024'" (generatePDFEmitter)="generatePDF($event)" [step]="step_details"
              [id]="step_details.id" (routeConfig)="showConfirm()" [schemeType]="'tdf'"
              [stepDetails]="step_details"></app-idex-utrr>

            <app-production-supply *ngSwitchCase="'tdf_025'" [id]="step_details.id" [step]="step_details"
              (generatePDFEmitter)="generatePDF($event)" (routeConfig)="showConfirm()"
              [stepDetails]="step_details"></app-production-supply>

            <app-tot *ngSwitchCase="'tdf_026'" [id]="step_details.id" [url]="'/tdf/documentation/tot/'"
              (routeConfig)="showConfirm()" [stepDetails]="step_details" [proposalName]="proposalName"></app-tot>
            <app-tot *ngSwitchCase="'tdf_faopd'" [id]="step_details.id" [url]="'/tdf/prototype/delivery/'"
              (routeConfig)="showConfirm()" [stepDetails]="step_details" [proposalName]="proposalName"></app-tot>
            <!-- <app-tot
              *ngSwitchCase="'P-PSQR'"
              [id]="step_details.id"
              [url]="'/tdf/psqr/pdd/'"
              (routeConfig)="showConfirm()"
              [stepDetails]="step_details"
              [proposalName]="proposalName"
            ></app-tot> -->



            <app-final-offer *ngSwitchCase="'tdf_019'" [id]="step_details.id" [step]="step_details"
              [getUrl]="'revenue/final-offer/'" [postUrl]="'/revenue/final-offer/'"
              (generatePDFEmitter)="generatePDF($event)" [stepDetails]="step_details"
              [schemeType]="'tdf'"></app-final-offer>

            <!-- Mass Production Phase -->
            <app-ssct *ngSwitchCase="'make1_009'" [proposalName]="proposalName"
              (generatePDFEmitter)="generatePDF($event)" [id]="step_details.id" [step]="step_details"
              (routeConfig)="showConfirm()" [stepDetails]="step_details" [proposalId]="proposalId"></app-ssct>

            <app-staff-evaluation *ngSwitchCase="'makeI_29'" [proposalName]="proposalName"
              (generatePDFEmitter)="generatePDF($event)" [id]="step_details.id" [step]="step_details"
              (routeConfig)="showConfirm()" [stepDetails]="step_details"
              [proposalId]="proposalId"></app-staff-evaluation>



            <app-aon *ngSwitchCase="'tdf_030'" [id]="step_details.id" [step]="step_details"
              [stepDetails]="step_details"></app-aon>

            <app-commercial-negocatition *ngSwitchCase="'tdf_031'" [id]="step_details.id" [step]="step_details"
              [schemeType]="'tdf'" [stepDetails]="step_details"
              (generatePDFEmitter)="generatePDF($event)"></app-commercial-negocatition>



            <app-preparation-of-psqr-fromm-pdd *ngSwitchCase="'P-PSQR'" [id]="step_details.id" [url]="'/tdf/psqr/pdd/'"
              (routeConfig)="showConfirm()" [stepDetails]="step_details"
              [proposalName]="proposalName"></app-preparation-of-psqr-fromm-pdd>
            <app-preparation-of-psqr-fromm-pdd *ngSwitchCase="'makeI_23'" [id]="step_details.id"
              [url]="'/tdf/psqr/sqr/'" (routeConfig)="showConfirm()" [stepDetails]="step_details"
              [proposalName]="proposalName"></app-preparation-of-psqr-fromm-pdd>

            <app-bulk-production *ngSwitchCase="'R_029'" [stepDetails]="step_details" [schemeType]="'tdf'"
              [proposalName]="proposalName"
              [urls]="{GPUrl:'/tdf/bulk/production/',TGPUrl:'/tdf/bulk-production/dates/'}"
              (routeConfig)="showConfirm()">
            </app-bulk-production>
            <app-project-closure *ngSwitchCase="'R_030'" [stepDetails]="step_details" [schemeType]="'tdf'"
              [proposalName]="proposalName" [urls]="{GPUrl:'/tdf/project/closure/'}"
              (routeConfig)="showConfirm()"></app-project-closure>
          </ng-container>
        </div>
      </div>

      <!-- REPORTS -->
      <div *ngIf="userGuide === 'report'">
        <app-report *ngIf="apiResponse" [schemeType]="'tdf'" [apiResponse]="apiResponse"></app-report>
      </div>
      <div *ngIf="userGuide === 'document'" class="px-3 pt-2 pb-4">
        <div class="border border-slate-200 rounded-xl shadow-sm bg-white overflow-hidden">

          <div
            class="flex items-center justify-between bg-blue-950 border-b-2 border-blue-600 px-5 py-3 gap-4 shadow-lg">

            <div class="flex items-center gap-3 shrink-0">
              <div class="bg-blue-800 p-2 rounded-lg shadow">
                <i class="pi pi-folder-open text-white text-[18px]"></i>
              </div>
              <h2 class="text-lg font-extrabold text-white tracking-tight whitespace-nowrap drop-shadow-sm uppercase">
                Document Management
              </h2>
            </div>

            <div class="flex items-center gap-3 w-full max-w-lg justify-end">

              <div class="relative w-full max-w-[320px]">
                <i class="pi pi-search absolute left-3.5 top-1/2 -translate-y-1/2 text-blue-400 text-base"></i>
                <input type="text"
                  class="pl-11 pr-2.5 py-2 w-full text-sm bg-white border-2 border-blue-400 rounded-lg focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 outline-none transition-all shadow"
                  placeholder="🔍 Search files..." [(ngModel)]="searchText"
                  (keyup.enter)="documentTable.filterGlobal(searchText, 'contains')" />
              </div>

              <button (click)="documentTable.clear()"
                class="flex items-center justify-center w-9 h-9 text-blue-600 bg-blue-50 hover:bg-blue-200 hover:text-blue-800 rounded-full transition-colors border border-blue-200 hover:border-blue-400 shadow"
                pTooltip="Clear Filters">
                <i class="pi pi-filter-slash text-base"></i>
              </button>
            </div>
          </div>

          <div class="p-2 border-b border-slate-100 bg-slate-50/30">
            <app-dmp [isEdit]="role_id === '20'" [proposalId]="proposalId"></app-dmp>
          </div>

          <ng-container *ngIf="documentList?.length; else noDocuments">
            <div class="overflow-x-auto">
              <p-table #documentTable [value]="documentList" [paginator]="documentList.length > 8" [rows]="8"
                styleClass="p-datatable-sm p-datatable-striped"
                [globalFilterFields]="['name', 'type_document', 'description']">
                <ng-template pTemplate="header">
                  <tr class="text-[11px] uppercase tracking-wider text-slate-500">
                    <th pSortableColumn="name" class="bg-white py-3">Name <p-sortIcon field="name"></p-sortIcon></th>
                    <th pSortableColumn="description" class="bg-white hidden md:table-cell">Description</th>
                    <th pSortableColumn="type_document" class="bg-white">Type</th>
                    <th class="bg-white text-center">Actions</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item>
                  <tr class="group hover:bg-blue-50/50 transition-colors border-b border-slate-50">
                    <td class="py-2">
                      <div class="flex items-center gap-2 px-2">
                        <i class="pi pi-file-pdf text-red-500 text-base"></i>
                        <span class="text-xs font-semibold text-slate-700 truncate max-w-[150px]"
                          [pTooltip]="item?.name">
                          {{ item?.name }}
                        </span>
                      </div>
                    </td>
                    <td class="py-2 hidden md:table-cell">
                      <span class="text-[11px] text-slate-500 italic">
                        {{ (item?.description?.length || 0) > 45 ? (item?.description | slice: 0 : 45) + '...' :
                        item?.description }}
                      </span>
                    </td>
                    <td class="py-2">
                      <span
                        class="px-2 py-0.5 rounded text-[10px] font-bold bg-blue-50 text-blue-600 border border-blue-100 uppercase">
                        {{ item?.type_document || 'N/A' }}
                      </span>
                    </td>
                    <td class="py-2 text-center">
                      <div class="flex justify-center gap-1">
                        <a [href]="baseUrl + (item?.file || '')" target="_blank"
                          class="w-7 h-7 flex items-center justify-center rounded-md bg-slate-100 text-slate-600 hover:bg-blue-600 hover:text-white transition-all">
                          <i class="pi pi-eye text-[10px]"></i>
                        </a>
                        <a *ngIf="item?.file" [href]="baseUrl + (item?.file || '')" [attr.download]="item?.name"
                          class="w-7 h-7 flex items-center justify-center rounded-md bg-slate-100 text-slate-600 hover:bg-green-600 hover:text-white transition-all">
                          <i class="pi pi-download text-[10px]"></i>
                        </a>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </ng-container>

          <ng-template #noDocuments>
            <div class="flex flex-col items-center justify-center py-12 bg-slate-50/50">
              <div class="w-16 h-16 bg-slate-200/50 rounded-full flex items-center justify-center mb-3">
                <i class="pi pi-folder-open text-slate-400 text-2xl"></i>
              </div>
              <h3 class="text-sm font-bold text-slate-700">No documents found</h3>
              <p class="text-xs text-slate-500 mt-1">Ready to upload? Use the section above.</p>
            </div>
          </ng-template>

        </div>
      </div>

      <!-- Comments -->
      <div *ngIf="userGuide === 'comments'">
        <div class="bg-white rounded shadow p-3 sticky top-4">
          <app-commenting-seet [id]="step_details.id" [stepDetails]="step_details"></app-commenting-seet>
        </div>
      </div>
    </div>
  </div>
</div>


<p-toast position="center" key="confirm" [baseZIndex]="9999">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-col w-full p-1">
      <div class="flex items-center gap-3 mb-4 bg-blue-50 p-3 rounded-xl border border-blue-100">
        <div class="w-10 h-10 bg-blue-600 text-white rounded-lg flex items-center justify-center shadow-lg">
          <i class="pi pi-send"></i>
        </div>
        <div>
          <h4 class="text-sm font-black text-blue-900 uppercase tracking-tighter">Action Required</h4>
          <p class="text-[10px] text-blue-700 font-medium">Step: {{ step_details?.name }}</p>
        </div>
      </div>
      <textarea
        class="w-full min-h-[60px] rounded-md border border-slate-300 p-2 mb-3 text-xs font-medium text-slate-700 resize-y focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
        placeholder="Add a comment or remarks for this action (optional)..." [(ngModel)]="comment"></textarea>

      <div class="flex flex-col gap-2">
        <button (click)="submitProposal(2)"
          class="w-full py-3 bg-blue-950 hover:bg-slate-900 text-white rounded-xl shadow-lg transition-all flex items-center justify-center gap-2 active:scale-95">
          <i class="pi pi-check-circle"></i>
          <span class="text-xs font-bold uppercase">Submit & Forward</span>
        </button>

        <div class="grid grid-cols-2 gap-2 mt-1">
          <button (click)="trigarFromChild()"
            class="py-2.5 bg-white border border-slate-200 hover:border-blue-300 text-slate-700 rounded-xl text-[10px] font-bold uppercase transition-all flex items-center justify-center gap-2">
            <i class="pi pi-cog"></i> Route Config
          </button>
          <button (click)="submitProposal(1)"
            class="py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-xl text-[10px] font-bold uppercase transition-all flex items-center justify-center gap-2">
            <i class="pi pi-save"></i> Save Draft
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>